export default __webpack_public_path__ + "static/media/CieSpid.8aff8741.png";